<template>
  <div class="container">
    <div class="column" id="DATA-FEEL">
      <div class="column-left">
        <div class="ico ico_data_feel"></div>
        <div class="text">数据感知</div>
      </div>
      <div class="column-right">
        <div class="item">
          <div class="info">
            <h4>边缘计算服务器</h4>
            <p>QJ-E8系列智能城市微场景计算服务器是立足于智能硬件集成技术，将物联网安全、智能算力IT基础设施完善融合，提供智能社区应用需求的设备。是全景智联以社区场景细腻的“难点”、“痛点”、“堵点”为导向，细节、深入服务所推出的模拟边缘计算设备。</p>
            <router-link tag="span" to="/byjsfwq" class="check-btn"
              >了解详情</router-link
            >
          </div>
          <div class="image">
            <img
              src="@/assets/images/productService/product1.png"
              style="width:28.3rem;height:12.64rem"
            />
          </div>
        </div>
        <!-- <div class="item">
          <div class="image">
            <img
              src="@/assets/images/productService/product2.png"
              style="width:28.3rem;height:12.93rem"
            />
          </div>
          <div class="info" style="padding-left:1.85rem">
            <h4>边缘智能分析盒</h4>
            <p>
              打造边缘感知中心，使设备成为感知信息处理中心，分布式设计降低了AI对云端的依赖，提升了稳定性和安全性。针对社区视频流数据庞大，难以高效实时处理问题，通过嵌入式神经网络处理器，直接对监控信息进行处理，实现对视频信息的实时分析。
            </p>
            <router-link tag="span" to="/bjznfxh" class="check-btn"
              >了解详情</router-link
            >
          </div>
        </div> -->
      </div>
    </div>
    <div class="column" id="DATA-ANALYSIC">
      <div class="column-left">
        <div class="ico ico_data_feel"></div>
        <div class="text">数据分析</div>
      </div>
      <div class="column-right">
        <div class="item">
          <div class="image">
            <img
              src="@/assets/images/productService/product9.png"
              style="width:28.3rem;height:21.85rem;"
            />
          </div>
          <div class="info" style="padding-left:1.85rem">
            <h4>大数据平台</h4>
            <p>作为一站式数据处理及分析平台，大数据平台以自有计算引擎为基础，深入智慧社区、智慧街道、市域社会治理等城市场景，一站式完成数据抽取、转换、共享、展现等，形成城市数据全生命周期管理体系。一方面使得城市场景具备敏捷应对、资源调度、智能预测的能力；另一方面，平台可在多个场景之间进行切换与赋能，能够放大城市场景数据资源的价值，进一步提升场景的安全性、高效性与便捷性。</p>
            <router-link tag="span" to="/dsjpt" class="check-btn"
              >了解详情</router-link
            >
          </div>
        </div>
        <div class="item">
          <div class="info">
            <h4>AIoT平台</h4>
            <!-- <p>
              是一个基于物联网、大数据、边缘计算等技术架构，面向政府基层单位搭建的市域治理数字孪生城市实战平台。能够实现街镇、社区治理数据的科学汇聚、分析、决策。
            </p> -->
            <p>AloT平台是一款高度智能化、模块化的基础支撑平台。它以城市微场景为场域，以物联网、AI技术为抓手，对场景海量终端设备及数据进行全生命周期管理，强化物联感知对顶层应用场景的支撑能力。一方面，平台支持对物联设备进行智慧化管理、预测性运维以及动态化监测；另一方面，平台具备多模态AI能力，可进行多维数据感知、全局态势洞察、实时决策分析、持续学习演进，辅助在复杂场景下做出最优决策。</p>
            <router-link tag="span" to="/aiot" class="check-btn"
              >了解详情</router-link
            >
          </div>
          <div class="image">
            <img
              src="@/assets/images/productService/product8.png"
              style="width:28.3rem;height:21.85rem;"
            />
          </div>
        </div>
        <!-- <div class="item">
          <div class="info">
            <h4>物联网智慧社区综合管理平台</h4>
            <p>
              是一个基于物联网、大数据、边缘计算等技术架构，面向政府基层单位搭建的市域治理数字孪生城市实战平台。能够实现街镇、社区治理数据的科学汇聚、分析、决策。
            </p>
            <router-link tag="span" to="/zhsqglpt" class="check-btn"
              >了解详情</router-link
            >
          </div>
          <div class="image">
            <img
              src="@/assets/images/productService/product3.png"
              style="width:28.3rem;height:21.85rem;"
            />
          </div>
        </div> -->
      </div>
    </div>
    <div class="column" id="DATA-SERVICE">
      <div class="column-left">
        <div class="ico ico_data_feel"></div>
        <div class="text">数据服务</div>
      </div>
      <div class="column-right">
        <div class="item">
          <div class="image">
            <img
              src="@/assets/images/productService/product6.png"
              style="width:28.3rem;height:21.85rem;"
            />
          </div>
          <div class="info" style="padding-left:1.85rem">
            <h4>社会基层治理平台</h4>
            <p>社会基层治理平台是以社区场景为载体的网格化管理平台。聚焦基层工作人员日常工作的痛点和难点，基于事件驱动、业务流转、多级联动的需求，结合大数据、物联网、云计算等技术，高效解决基层日常管理问题。辅助基层政府部门进行工作模式升级，切实提升基层治理水平，维护社会稳定。
            </p>
            <router-link tag="span" to="/jczlpt" class="check-btn"
              >了解详情</router-link
            >
          </div>
        </div>
        <div class="item">
          <div class="info">
            <h4>物联网智慧社区平台</h4>
            <p>是一个基于物联网、大数据、边缘计算等技术架构，面向政府基层单位搭建的市域治理数字孪生城市实战平台。能够实现街镇、社区治理数据的科学汇聚、分析、决策。</p>
            <router-link tag="span" to="/zhsqglpt" class="check-btn"
              >了解详情</router-link
            >
          </div>
          <div class="image">
            <img
              src="@/assets/images/productService/product3.png"
              style="width:28.3rem;height:21.85rem;"
            />
          </div>
        </div>
        <!-- <div class="item">
          <div class="info" style="padding-left:1.85rem">
            <h4>物联网智慧社区平台</h4>
            <p>
              社区业务管理平台主要应用于互联网环境（支持私有化部署）。通过平台可检测社区前端接入的所有物联网感知设备运行态势，从而达到对小区的全方位把控，社区业务管理平台将感知设备如门禁、视频、物业服务等场景集成统一平台，通过对分散数据的汇聚，为数据服务提供有效支撑。
            </p>
            <router-link tag="span" to="/sqfwpt" class="check-btn"
              >了解详情</router-link
            >
          </div>
          <div class="image">
            <img
              src="@/assets/images/productService/product4.png"
              style="width:28.3rem;height:21.85rem;"
            />
          </div>
        </div> -->
        <div class="item">
          <div class="image">
            <img
              src="@/assets/images/productService/product5.png"
              style="width:28.3rem;height:15.92rem"
            />
          </div>
          <div class="info" style="padding-left:1.85rem">
            <h4>屋畔</h4>
            <!-- <p>
              提供综合性社区服务集中解决方案，在涵盖多种智能开门方式的基础上，结合独有的线上线下运营模式，将多种场景的便民惠民服务融合于社区统一场景下，旨在建设更为美好的社区生活，形成合力向善的新生态环境。
            </p> -->
            <p>屋畔社区服务产品，以服务为核心，为政府、商户（服务组织）以及居民提供综合性社区服务。PC端和移动端，高效适配不同场景和用户，包含政府管理、运营管理和服务管理。屋畔深挖社区场景数据价值，纵向打通政府-居民管理链路，在进行日常管理的同时，进行政务服务输送；横向打通商户（服务组织）—居民服务链条，为居民准确推送便民服务，提升生活品质。</p>
            <router-link tag="span" to="/wp" class="check-btn"
              >了解详情</router-link
            >
          </div>
        </div>
        <div class="item">
          <div class="info">
            <h4>网格中心小程序</h4>
            <p>支撑网格员开展事件上报，任务查询、信息收集等日常工作，加强线上基层治理事件处理，简化工作流程，全面、及时的掌握居民基本信息，切实推进智慧治理。</p>
            <router-link tag="span" to="/wgzxxcx" class="check-btn"
              >了解详情</router-link
            >
          </div>
          <div class="image">
            <img
              src="@/assets/images/productService/product7.png"
              style="width:28.3rem;height:15.92rem"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "layout"
};
</script>

<style lang="less" scoped>
.container {
  padding: 5.2rem 4.8rem;
  overflow: hidden;
  .column {
    margin-bottom: 6rem;
    display: flex;
    &:first-child {
      // height: 60.1rem;
      height: 30rem;
    }
    &:nth-child(2) {
      // height: 30rem;
      height: 70.1rem;
    }
    &:last-child {
      // height: 126.1rem;
      height: 100.1rem;
    }
    &:last-child {
      margin-bottom: 0 !important;
    }
    .column-left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 0 0 12.85rem;
      background: linear-gradient(180deg, #1c98e0 0%, #105da8 100%);
      .ico {
        background-repeat: no-repeat;
        background-size: 100%;
        &.ico_data_feel {
          width: 4.5rem;
          height: 5.01rem;
          background-image: url("~@/assets/images/productService/ico_data_feel.png");
        }
      }
      .text {
        margin-top: 1.5rem;
        font-size: 1.6rem;
        font-weight: bold;
        color: #ffffff;
      }
    }
    .column-right {
      flex: 1;
      padding: 6rem 1.5rem 0 2rem;
      background-color: #f2f3f5;

      .item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 13.5rem;
        /* &:first-child {
          margin-bottom: 13.5rem;
        } */
        .info {
          margin-top: 1rem;
          padding-right: 1.35rem;
          h4 {
            font-size: 1.6rem;
            font-weight: 600;
            color: #2a2e2e;
            line-height: 2.25rem;
          }
          p {
            text-indent: 1.6rem;
            margin-top: 1.15rem;
            font-size: 0.8rem;
            color: #666666;
            line-height: 1.6rem;
          }
          .check-btn {
            display: inline-block;
            width: 9rem;
            height: 2.3rem;
            line-height: 2.3rem;
            margin-top: 2rem;
            font-size: 0.9rem;
            color: #2f61ae;
            text-align: center;
            border: 1px solid #2f61ae;
            cursor: pointer;
            &:hover {
              background: rgba(14, 87, 162, 0.1);
            }
          }
        }
      }
    }
  }
}
</style>
